/**
 * Created by 马荣钦 on 2016/2/2.
 */
"use strict";
angular.module('editOutSendingAddModule',[])
    .controller("editOutSendingAddCtrl",["$scope","$modalInstance","$validation","params","modalDialog",function($scope,$modalInstance,$validation,params,modalDialog){
        $scope.title="添加联系人";
        //关闭窗口
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        if(params){
           $scope.title="编辑联系人";
           $scope.email=params.EMAIL;
           $scope.desc= params.EMAILDESC;
        }
        $scope.confirm = function() {
            $validation.validate($scope.outSendingAddForm).success(function() {
                $modalInstance.close({
                    email:$scope.email,
                    emailDesc:$scope.desc
                });
            }).error(function(){
                modalDialog.alertType('请检查填写项!', '', 'error', false);
            });
        };
    }]);